import IconGeneric from './IconGeneric';

export default IconGeneric;
